module.exports = __webpack_public_path__ + "img/MONEY.dac28231.svg";